import React, { useState, useRef } from "react";
import { apiFactory } from "services/ApiFactory";
import { notifyError, notifySuccess } from "utils/utils";
import { Row, Col, Input, Button } from "reactstrap";
import useTheme from "hooks/useTheme";

const ProfileSecurity = ({ onClose, page, history }) => {
  const [code, setCode] = useState("");
  const validationRef = useRef(null);
  const themeInformation = useTheme();

  var currentUser =
    apiFactory.intranetApiFactory.generalInformation.getPresentUserGeneralInfo();

  const sendVerificationSMSCode = async () => {
    await apiFactory.intranetApiFactory.profileSecurity
      .setAsync(currentUser.userId)
      .then((response) => {

        if (!response.data.hasErrorMessage) {
          notifySuccess({
            width: "400px",
            message: "لطفا کد ارسال شده را جهت اعتبارسنجی وارد کنید",
            timeout: 5000
          });
          validationRef.current.focus();
          validationRef.current.select();          
        } else {
          notifyError({
            width: "350px",
            message: "ارسال پیامک تاییده با خطا مواجه گردید",
          });
        }
      })
      .catch((err) => {
        debugger;
      });
  };



  const confirmVerificationCode = () => {
    // history.push(page);
    apiFactory.intranetApiFactory.profileSecurity
      .check(currentUser.userId, code)
      .then((response) => {        
        removeVerificationSMSCode();
        if (response.data) {
          history.push(page);
        } else {
          notifyError({
            width: "350px",
            message: "کد وارد شده معتبر نمی باشد.",
          });
          history.push('/');
        }
        onClose();
        if (!response.data.hasErrorMessage) {
        } else {
          notifyError({
            width: "350px",
            message: "اعتبار سنجی پیامک ارسالی با خطا مواجه گردید",
          });
        }
      })
      .catch((err) => {});
  };

  const removeVerificationSMSCode = () => {
    apiFactory.intranetApiFactory.profileSecurity
      .remove(currentUser.userId)
      .then((response) => {
      })
      .catch((err) => {});
  };

  const onCodeChanged = key => {
    setCode(key);
  };

  const onKeyDown = e => {
    if (e.key === 'Enter') {
      confirmVerificationCode();
    }
  }



  return (
    <div>
      <Row>
        <Col           
          className="mt-2 h6" 
          xs={6} sm={6} md={5} lg={5}
        >
          کد پیامک شده :
        </Col>
        <Col xs={6} sm={6} md={7} lg={7}>
          {/* <Input onChange={(e) => onchange(e.target.value)}/> */}
          <input className='form-control' ref={validationRef} autoFocus onKeyDown={(e) => onKeyDown(e)} onChange={(e) => onCodeChanged(e.target.value)} />
        </Col>
      </Row>
      <Row>
        <div
          className="mt-3"
          style={{ borderTop: "1px solid #c8ced3", width: "100%", display: "flex" }}
        >
          <Col style={{ padding: "5px" }} sx={12} sm={12} md={3} lg={3}>
            <Button
              style={{ width: "100%", paddingLeft: "0px", paddingRight: "0px" }}
              active
              color="warning"
              outline
              size="md"
              onClick={() => sendVerificationSMSCode()}
            >
              ارسال پیامک
            </Button>
          </Col>
          <Col style={{ padding: "5px", paddingRight: "0px" }} sx={12} sm={12} md={3} lg={3}>
            <Button
              style={{ width: "100%" }}
              active
              color="success"
              outline
              size="md"
              onClick={() => confirmVerificationCode()}
            >
              تایید
            </Button>
          </Col>
          <Col style={{ padding: "5px", paddingRight: "0px" }} sx={12} sm={12} md={3} lg={3}>
            <Button
              style={{ width: "100%" }}
              active
              color="primary"
              outline
              size="md"
              onClick={onClose}
            >
              بستن
            </Button>
            </Col>
          <Col style={{ padding: "5px" }} sx={12} sm={12} md={3} lg={3}>
          </Col>
        </div>
      </Row>
    </div>
  );
};

export default ProfileSecurity;
